var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C11.58 8 8 11.58 8 16C8 19.54 10.29 22.53 13.47 23.59C13.87 23.66 14.02 23.42 14.02 23.21C14.02 23.02 14.01 22.39 14.01 21.72C12 22.09 11.48 21.23 11.32 20.78C11.23 20.55 10.84 19.84 10.5 19.65C10.22 19.5 9.82 19.13 10.49 19.12C11.12 19.11 11.57 19.7 11.72 19.94C12.44 21.15 13.59 20.81 14.05 20.6C14.12 20.08 14.33 19.73 14.56 19.53C12.78 19.33 10.92 18.64 10.92 15.58C10.92 14.71 11.23 13.99 11.74 13.43C11.66 13.23 11.38 12.41 11.82 11.31C11.82 11.31 12.49 11.1 14.02 12.13C14.66 11.95 15.34 11.86 16.02 11.86C16.7 11.86 17.38 11.95 18.02 12.13C19.55 11.09 20.22 11.31 20.22 11.31C20.66 12.41 20.38 13.23 20.3 13.43C20.81 13.99 21.12 14.7 21.12 15.58C21.12 18.65 19.25 19.33 17.47 19.53C17.76 19.78 18.01 20.26 18.01 21.01C18.01 22.08 18 22.94 18 23.21C18 23.42 18.15 23.67 18.55 23.59C21.71 22.53 24 19.53 24 16C24 11.58 20.42 8 16 8Z",
    fill: "#28292B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.7d13e033dbcdee3693722f7e86a7c6ff.svg";
export { ForwardRef as ReactComponent };